export default class DashboardModel {
  constructor(item = {}) {
    this.by_city = item.by_city?.map(item => new CityModel(item)) || []
    this.by_course_option = item.by_course_option?.map(item => new CategoryModel(item)) || []
    this.by_course_type = item.by_course_type?.map(item => new CourseTypeModel(item)) || []
    this.by_course_type_total = item.by_course_type_total?.map(item => new CourseTypeModel(item)) || []
    this.by_exam_results = item.by_exam_results?.map(item => new ExamResultsModel(item)) || []
    this.by_exam_type = item.by_exam_type?.map(item => new ExamTypeModel(item)) || []
    this.by_extra_exams_les = item.by_extra_exams_les?.map(item => new ExtraExamsModel(item)) || []
    this.by_extra_exams_online = item.by_extra_exams_online?.map(item => new ExtraExamsModel(item)) || []
    this.by_location = item.by_location?.map(item => new LocationModel(item)) || []
    this.by_package = item.by_package?.map(item => new PackageModel(item)) || []
    this.by_offline_day_packages = Array.isArray(item.by_offline_day_packages)
      ? item.by_offline_day_packages.map(item => new OfflineDayPackageModel(item))
      : []
    this.by_promo_campaign = item.by_promo_campaign?.map(item => new PromoCampaignModel(item)) || []
    this.by_driving_school = Array.isArray(item.by_driving_school)
      ? item.by_driving_school.map(item => new DrivingSchoolModel(item))
      : []
  }
}

export class CountModel {
  constructor(item = {}) {
    this.name = item.name
    this.count = item.cnt || 0
  }
}

export const OFFLINE_ROWS_WITH_PACKAGES = ['New Offline', 'Total Offline']

export const OFFLINE_PACKAGE_NAMES = ['Compleet', 'Compleet Plus', 'Compleet Max']

export class OfflinePackageModel {
  constructor(item = {}) {
    this.name = item.name
    this.total = item.total || 0
    this.unique = item.unique || 0
    this.paid = item.paid || 0
    this.ratio = getRatio(item.ratio)
    this.paid_wn_15m = item.paid_wn_15m || 0
    this.paid_wn_24h = item.paid_wn_24h || 0
  }
}

export class CourseTypeModel {
  constructor(item = {}) {
    this.name = item.name
    this.paid = item.paid || 0
    this.paid_wn_15m = item.paid_wn_15m || 0
    this.paid_wn_24h = item.paid_wn_24h || 0
    this.ratio = getRatio(item.ratio)
    this.total = item.total || 0
    this.unique = item.unique || 0
    this.children = OFFLINE_ROWS_WITH_PACKAGES.includes(item.name) && item.children?.length
      ? OFFLINE_PACKAGE_NAMES
        .map(name => item.children.find(child => child.name === name))
        .filter(Boolean)
        .map(child => new OfflinePackageModel(child))
      : []
  }
}

export class CityModel extends CountModel {}

export class LocationModel extends CountModel {}

export class CategoryModel extends CountModel {}

export class PackageModel {
  constructor(item = {}) {
    this.name = item.name
    this.payments_count = item.payments_count || 0
    this.money = item.money || 0
  }
}

export class OfflineDayPackageModel {
  constructor(item = {}) {
    this.name = item.name
    this.amount = item.amount || 0
    this.money = item.money || 0
  }
}

export class ExtraExamsModel {
  constructor(item = {}) {
    this.name = item.name
    this.money = item.money || 0
    this.payments_count = item.payments_count || 0
  }
}

export class ExamTypeModel {
  name;
  new_offline;
  reapply_offline;
  new_paid_offline;
  reapply_paid_offline;
  new_paid_unique_offline;
  reapply_paid_unique_offline;
  new_online;
  reapply_online;
  new_paid_online;
  reapply_paid_online;
  new_paid_unique_online;
  reapply_paid_unique_online;
  total;
  constructor(item = {}) {
    this.name = item.name
    this.new_offline = item.new_offline || 0
    this.reapply_offline = item.reapply_offline || 0
    this.new_paid_offline = item.new_paid_offline || 0
    this.reapply_paid_offline = item.reapply_paid_offline || 0
    this.new_paid_unique_offline = getRatio(item.new_paid_unique_offline)
    this.reapply_paid_unique_offline = getRatio(item.reapply_paid_unique_offline)
    this.new_online = item.new_online || 0
    this.reapply_online = item.reapply_online || 0
    this.new_paid_online = item.new_paid_online || 0
    this.reapply_paid_online = item.reapply_paid_online || 0
    this.new_paid_unique_online = getRatio(item.new_paid_unique_online)
    this.reapply_paid_unique_online = getRatio(item.reapply_paid_unique_online)
    this.total = item.total || 0
  }
}

export class ExamResultsModel {
  constructor(item = {}) {
    this.status = item.status
    this.count = item.count || 0
    this.ratio = getRatio(item.ratio)
  }
}

export class PromoCampaignModel {
  constructor(item = {}) {
    this.campaign_type = item.campaign_type || ''
    this.source = item.promo_campaign_source || ''
    this.promo_code = item.promo_code || ''
    this.total_offline = item.total_offline || 0
    this.unique_offline = item.unique_offline || 0
    this.paid_offline = item.paid_offline || 0
    this.total_online = item.total_online || 0
    this.unique_online = item.unique_online || 0
    this.paid_online = item.paid_online || 0
  }
}

export class DrivingSchoolModel extends PromoCampaignModel {
  constructor(item = {}) {
    super(item)
    this.total_all_in = item.total_all_in || 0
    this.unique_all_in = item.unique_all_in || 0
    this.paid_all_in = item.paid_all_in || 0
  }
}

function getRatio(item) {
  if (item) return `${ (+item).toFixed(2) } %`
  else return '0 %'
}

